import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import ww from "./assets/images/ww.png";
import Home from "./pages/Home";
import Landing from "./pages/Landing";
import PrivacyPolicy from "./PrivacyPolicy";

const App = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="bg-Secondary body text-white overflow-hidden ">
      <div
        className={`fixed md:bottom-10 bottom-4 right-0 md:right-4  px-2 py-3  rounded-lg z-20 cursor-pointer bg `}
      >
        <a href={"whatsapp://send?phone=+971504681550"} target={"_blank"}>
          <img
            src={ww}
            alt=""
            className="!cursor-pointer relative -z-10 -rotate-90 w-24 md:w-24 animate-pulse"
          />
        </a>
      </div>

      <Routes>
        <Route
          path="/"
          element={
            <>
              <div className="max-md:hidden">
                <Home />
              </div>
              <div className="md:hidden">
                <Landing />
              </div>
            </>
          }
        />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </div>
  );
};

export default App;
